import { Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class AuthGuard {
  // implements CanActivate {

  constructor(
    public router: Router,
    public authenticationService: AuthenticationService
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    let result = false;
    if (!this.authenticationService.isauthenticated) {
      this.authenticationService.login();
    } else {
      result = true;
    }

    return result;
  }
}
